<template>
  <div class="App">
    <div
      class="LoaderContainer"
      v-show="!appLoaded"
    >
      <img
        class="Logo"
        src="@/assets/Roche_Logo.png"
      >
      <div class="sk-circle">
        <div class="sk-circle1 sk-child" />
        <div class="sk-circle2 sk-child" />
        <div class="sk-circle3 sk-child" />
        <div class="sk-circle4 sk-child" />
        <div class="sk-circle5 sk-child" />
        <div class="sk-circle6 sk-child" />
        <div class="sk-circle7 sk-child" />
        <div class="sk-circle8 sk-child" />
        <div class="sk-circle9 sk-child" />
        <div class="sk-circle10 sk-child" />
        <div class="sk-circle11 sk-child" />
        <div class="sk-circle12 sk-child" />
      </div>
    </div>
    <Interface v-show="appLoaded" />
  </div>
</template>

<script>
import Interface from '@/components/Interface/Interface.vue'
import { ValidateCode } from '@/components/Code/CodeValidator'
import tables from '@/settings/tables.json'
import { EventBus } from '@/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    Interface
  },
  computed: {
    ...mapGetters(['appLoaded'])
  },
  methods: {
    Login () {
      this.Logged = true
    }
  },
  mounted () {
    console.log(process.env.VUE_APP_URL)
    EventBus.$on('AppLoaded', () => {
      // DEBUG
      this.$store.dispatch('SetDebug', false)
      this.$store.dispatch('SetLangData')
      this.$store.dispatch('SetStep', 0)
      var userLang = navigator.language || navigator.userLanguage
      this.$store.dispatch('SetLang', userLang)
      if (this.$route.query.params) {
        const code = ValidateCode(this.$route.query.params)
        if (code === null) {
          this.valid = false
        } else {
          this.$store.dispatch('SetStep', 3)
          this.$store.dispatch('SetTable', tables[code.type])
          this.$store.dispatch('SetSliders', code.rotations)
          this.$store.dispatch('SetUVs', code.uvs)
          this.$store.dispatch('SetForces', code.forces)
        }
      }
      if (this.$route.query.lang) {
        this.$store.dispatch('SetLang', this.$route.query.lang)
      }
    })
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap');

html,
body,
.App {
  width: 100%;
  height: 100%;
  background: url('https://resources.roche-bobois.com/corail/assets/arriere-plan-flou-blanc-gris-clair-degrade-radial_53562-6788.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}
body {
  line-height: 1;
}
ol,
ul {
  list-style: none;
}
blockquote,
q {
  quotes: none;
}
blockquote:before,
blockquote:after,
q:before,
q:after {
  content: '';
  content: none;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}

button {
  border: none;
  background: none;
  outline: none;
}

#App {
  margin: 0;
  padding: 0;
}
@import url('https://use.typekit.net/jtg1aag.css');

* {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-style: normal;
}

</style>

<style scoped>
.LoaderContainer{
  width: 100%;
  height:100%;
  background: rgb(243, 243, 243);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  pointer-events: none;
  flex-direction: column;
}

.sk-circle {
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;
  width: 40px;
  height: 40px;
  position: relative;
}
.sk-circle .sk-child {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.sk-circle .sk-child:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: black;
  opacity: 0.5;
  border-radius: 100%;
  -webkit-animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
          animation: sk-circleBounceDelay 1.2s infinite ease-in-out both;
}
.sk-circle .sk-circle2 {
  -webkit-transform: rotate(30deg);
      -ms-transform: rotate(30deg);
          transform: rotate(30deg); }
.sk-circle .sk-circle3 {
  -webkit-transform: rotate(60deg);
      -ms-transform: rotate(60deg);
          transform: rotate(60deg); }
.sk-circle .sk-circle4 {
  -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
          transform: rotate(90deg); }
.sk-circle .sk-circle5 {
  -webkit-transform: rotate(120deg);
      -ms-transform: rotate(120deg);
          transform: rotate(120deg); }
.sk-circle .sk-circle6 {
  -webkit-transform: rotate(150deg);
      -ms-transform: rotate(150deg);
          transform: rotate(150deg); }
.sk-circle .sk-circle7 {
  -webkit-transform: rotate(180deg);
      -ms-transform: rotate(180deg);
          transform: rotate(180deg); }
.sk-circle .sk-circle8 {
  -webkit-transform: rotate(210deg);
      -ms-transform: rotate(210deg);
          transform: rotate(210deg); }
.sk-circle .sk-circle9 {
  -webkit-transform: rotate(240deg);
      -ms-transform: rotate(240deg);
          transform: rotate(240deg); }
.sk-circle .sk-circle10 {
  -webkit-transform: rotate(270deg);
      -ms-transform: rotate(270deg);
          transform: rotate(270deg); }
.sk-circle .sk-circle11 {
  -webkit-transform: rotate(300deg);
      -ms-transform: rotate(300deg);
          transform: rotate(300deg); }
.sk-circle .sk-circle12 {
  -webkit-transform: rotate(330deg);
      -ms-transform: rotate(330deg);
          transform: rotate(330deg); }
.sk-circle .sk-circle2:before {
  -webkit-animation-delay: -1.1s;
          animation-delay: -1.1s; }
.sk-circle .sk-circle3:before {
  -webkit-animation-delay: -1s;
          animation-delay: -1s; }
.sk-circle .sk-circle4:before {
  -webkit-animation-delay: -0.9s;
          animation-delay: -0.9s; }
.sk-circle .sk-circle5:before {
  -webkit-animation-delay: -0.8s;
          animation-delay: -0.8s; }
.sk-circle .sk-circle6:before {
  -webkit-animation-delay: -0.7s;
          animation-delay: -0.7s; }
.sk-circle .sk-circle7:before {
  -webkit-animation-delay: -0.6s;
          animation-delay: -0.6s; }
.sk-circle .sk-circle8:before {
  -webkit-animation-delay: -0.5s;
          animation-delay: -0.5s; }
.sk-circle .sk-circle9:before {
  -webkit-animation-delay: -0.4s;
          animation-delay: -0.4s; }
.sk-circle .sk-circle10:before {
  -webkit-animation-delay: -0.3s;
          animation-delay: -0.3s; }
.sk-circle .sk-circle11:before {
  -webkit-animation-delay: -0.2s;
          animation-delay: -0.2s; }
.sk-circle .sk-circle12:before {
  -webkit-animation-delay: -0.1s;
          animation-delay: -0.1s; }

@-webkit-keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

@keyframes sk-circleBounceDelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0);
  } 40% {
    -webkit-transform: scale(1);
            transform: scale(1);
  }
}

.Logo {
  margin-top: auto;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 1em;
  min-width: 200px;
  max-width: 200px;
  height: auto;
}
</style>
